import { render, staticRenderFns } from "./repsol-dual-list.component.html?vue&type=template&id=48389f0c&external"
import script from "./RepsolDualListComponent.vue?vue&type=script&lang=ts"
export * from "./RepsolDualListComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports